import Vue from "vue";

import request from "../../helpers/request.js";

const state = Vue.observable({
    filters: {
        keywords: null,
        types: [],
        categories: [],
        tags: [],
        favourites: false,
        customImage: false,
        customText: false
    },
    metaData: {}
});

export const search = async (query) => {
    return await request.get(`${SEARCH_API_URL}/list`, {
        params: query
    });
};

export const filters = async (types, culture) => {
    return await request.get(`${SEARCH_API_URL}/filters`, {
        params: {
            types,
            culture
        }
    });
};

export const autocomplete = async () => {
    return await request.get(`${SEARCH_API_URL}/autocomplete`);
};

export default {
    state: state,
    search: search,
    filters: filters,
    autocomplete: autocomplete
};